<script setup>
import Navigation from '@/Components/Navigation.vue';
import Footer from "@/Components/Footer.vue";
const props = defineProps(['layout']);

const css = {
    'container': true,
    'justify-content-center': true,
    'align-items-center': true,
    'd-flex': (props.layout && props.layout == 'vertical') ? false : true
};
</script>
<template>
    <Navigation/>
    <main :class="css">          
        <slot />
    </main>
    <Footer/>
</template>
<style>
</style>